export default "__VITE_ASSET__DoikT0iM__"